import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PatternIcon from '@mui/icons-material/Pattern';
import { colors, Link as MuiLink, styled, Link } from '@mui/material';
import { AssessmentOutlined } from '@mui/icons-material';

interface StyledLinkProps {
  selected?: boolean;
}

// Create a styled Link component
const StyledLink = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<StyledLinkProps>(({ theme, selected }) => ({
    textDecoration: 'none', // Remove the underline
    color: 'inherit', // Keep the default color
    display: 'flex', // Ensure the link is a flex container
    alignItems: 'center', // Align items vertically
    width: '100%',
    padding: theme.spacing(2.5, 2.5),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: selected ? theme.palette.action.selected : 'transparent',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.action.selected,
      '&:hover': {
        backgroundColor: theme.palette.action.selected,
      },
    },
  }));

  
export const mainListItems = (location: string) => {

  return (
    <React.Fragment>
      <StyledLink 
        selected={location === '/payslip' || location === '/home'} 
        className={location === '/payslip' || location === '/home' ? 'Mui-selected' : ''}
        href='/payslip'
      >
          <ListItemIcon sx={{ color: 'inherit' }}>
            <ReceiptIcon />
          </ListItemIcon>
          <ListItemText primary="Payslip" />
      </StyledLink>
      <StyledLink 
        selected={location === '/messages'} 
        className={location === '/messages' ? 'Mui-selected' : ''}
        href='/messages'
      >
        <ListItemIcon sx={{ color: 'inherit' }} >
          <MailOutlineIcon />
        </ListItemIcon>
        <ListItemText primary="Messages" />
      </StyledLink>
    </React.Fragment>
  );
};

export const secondaryListItems = (location: string, superAdmin: boolean) => {

    return (
    <React.Fragment>
      <ListSubheader component="div" inset>
        <strong>ADMIN</strong>
      </ListSubheader>
      <StyledLink 
        selected={location === '/pensioners' || location === '/home'}
        className={location === '/pensioners' ? 'Mui-selected' : ''}
        href='/pensioners'>
        <ListItemIcon sx={{ color: 'inherit' }}>
          <PeopleOutlineIcon />
        </ListItemIcon>
        <ListItemText primary="Pensioners" />
      </StyledLink>  
      {superAdmin && (
      <StyledLink 
        selected={location === '/admin-users'}
        className={location === '/admin-users' ? 'Mui-selected' : ''}
        href='/admin-users'
      >
        <ListItemIcon sx={{ color: 'inherit' }}>
          <SupervisorAccountIcon />
        </ListItemIcon>
        <ListItemText primary="Admin Users" />
      </StyledLink>
      )}
      <StyledLink 
        selected={location === '/login-activities'}
        className={location === '/login-activities' ? 'Mui-selected' : ''}
        href='/login-activities'
      >
        <ListItemIcon sx={{ color: 'inherit' }}>
          <PatternIcon />
        </ListItemIcon>
        <ListItemText primary="Login Activities" />
      </StyledLink>
      <StyledLink 
        selected={location === '/payslip-change'}
        className={location === '/payslip-change' ? 'Mui-selected' : ''}
        href='/payslip-change'>
        <ListItemIcon sx={{ color: 'inherit' }}>
          <AssessmentOutlined />
        </ListItemIcon>
        <ListItemText primary="Payslip Changed" />
      </StyledLink>
    </React.Fragment>
  );
}